import React from 'react';
import useStyle from './productLinePanierVariant.style';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import useIsMobile from 'helpers/responsive/useIsMobile';
import { CommandeLinePanier } from '../../../../types/commandeLine/commandeLine.def';
import { mediaDir } from 'appolloConfig';
import { Select } from 'components/atoms/Inputs/Select';

export interface ProductLinePanierVariantViewProps {
  line: CommandeLinePanier;
  price: string;
  onClickViewMore: () => void;
  onClickTrash: () => void;
  updateCartQuantity: (newQtd: number) => void;
}

export const ProductLinePanierVariantView = ({
  line,
  price,
  onClickViewMore,
  onClickTrash,
  updateCartQuantity
}: ProductLinePanierVariantViewProps) => {
  const classes = useStyle();
  const isMobile = useIsMobile();

  return (
    <div className={classes.root}>
      <div className={classes.line1}>
        <div className={classes.line2}>
          <img
            className={classes.image}
            src={mediaDir + line?.produit?.media[0]?.url}
            alt={line?.produit?.name}
          />
          <div>
            <p className={classes.nom}>{line?.produit?.name}</p>
            <p>{line?.produit?.ttcPrice} € unité</p>
          </div>
        </div>
        <div className={classes.line25}>
          <Select
            value={line.quantite}
            onChange={(n: number) => updateCartQuantity(n)}
            maxValue={1000}
          />
          <div>{price} €</div>
        </div>
      </div>
      <div className={classes.line3}>
        <ButtonWithText
          icon={'MoreAbout'}
          variant={'text'}
          content={!isMobile ? 'Fiche produit' : ''}
          onClick={onClickViewMore}
        />
        <ButtonWithText
          icon={'Trash'}
          iconColor={'#D12B3F'}
          variant={'textDanger'}
          content={!isMobile ? 'Supprimer le produit' : ''}
          onClick={onClickTrash}
        />
      </div>
    </div>
  );
};
